import React from 'react';

function SideBarLineSvg() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='46'
			height='4'
			viewBox='0 0 46 4'
		>
			<rect
				id='Rectangle_496'
				data-name='Rectangle 496'
				width='4'
				height='46'
				transform='translate(0 4) rotate(-90)'
				fill='#22294d'
			/>
		</svg>
	);
}

export default SideBarLineSvg;
